var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 394,
    viewBox: "0 0 1440 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.395485,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.6357C0 32.6357 283.196 77.9059 548.438 77.9059C813.679 77.9059 949.747 16.3316 1106.44 3.12024C1263.13 -10.0911 1440 32.6357 1440 32.6357V394H0V32.6357Z",
    fill: "url(#paint0_linear_37_302)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_302",
    x1: 1206.14,
    y1: 492.074,
    x2: 1268.09,
    y2: -58.8713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421554"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/Footer.c0bcc56b187fa15b7cd92e19f55e1648.svg";
export { ForwardRef as ReactComponent };